import React from 'react';
/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 07/05/18
 */

import Indonesia from './Indonesia';

const TCash = () => {
  return <Indonesia />;
};

export default TCash;
